import { Component } from '@angular/core';

@Component({
  selector: 'app-message-one',
  templateUrl: './message-one.component.html',
  styleUrls: ['./message-one.component.scss']
})
export class MessageOneComponent {

}
